import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLoader } = FiIcons;

export default function Spinner({ size = 24, className = '' }) {
  return (
    <div className={`flex justify-center items-center ${className}`}>
      <SafeIcon icon={FiLoader} size={size} className="animate-spin text-blue-500" />
    </div>
  );
}